<!-- PersonTable.vue -->
<template>
  <div id="list">
    <div>
      <RepresentativeInfo
        v-if="config.hasRepresentative"
        :representative="team.team.representative"
        @openProfile="openProfile"
      />
      <EstimationPrompt v-if="showEstimationError" />

      <v-layout row wrap align-center justify-space-between class="estimation-search-row">
        <!-- LEFT: Estimation Prompt -->
        <v-flex xs12 sm6 md7>
          <CounterDisplay
            v-if="estimate != null"
            :count="persons.length"
            :total="estimate"
            :titleKey="config.titleKey"
            :isPlayers="config.id === 'players'"
            @change-estimate="openEstimation"
          />
        </v-flex>

        <!-- RIGHT: Search Input -->
        <v-flex xs12 sm6 md5>
          <SearchInput v-model="search" />
      </v-flex>
      </v-layout>
    </div>

    <DataTableWrapper
      :config="config"
      :items="persons"
      :search="search"
      :event="event"
      @edit="openProfile"
      @remove="openDialog"
      @transfer="onOpenTransferDialog"
    />

    <ConfirmPopup
      @close="cancel"
      @confirm="deleteConfirm"
      :dialog="confirmPopUpDialog"
    />
    <EstimationDialog
      :value="showEstimationDialog"
      :estimate="estimate"
      :estimateMinimum="estimateMinimum"
      :errorKey="errorKey()"
      :error="error"
      @update="onUpdateEstimate"
      @error="onErrorEstimate"
      @input="onDialogToggle"
    />
    <TeamTransferDialog
      :value="showTransferDialog"
      :team="team"
      :categories="categories"
      :persons="persons"
      :personId="personTransferId"
      :playersException="playersException"
      :transferError="transferError"
      :loading="isTransferring"
      @input="onTransferDialog"
      @confirm="onTransferConfirm"
    />
  </div>
</template>

<script>
import RepresentativeInfo from './RepresentativeInfo.vue'
import EstimationPrompt from './EstimationPrompt.vue'
import CounterDisplay from './CounterDisplay.vue'
import SearchInput from './SearchInput.vue'
import DataTableWrapper from './DataTableWrapper.vue'
import EstimationDialog from './EstimationDialog.vue'
import TeamTransferDialog from './TeamTransferDialog.vue'
import ConfirmPopup from '../ConfirmPopup.vue'

export default {
  name: 'PersonTable',
  components: {
    RepresentativeInfo,
    EstimationPrompt,
    CounterDisplay,
    SearchInput,
    DataTableWrapper,
    ConfirmPopup,
    EstimationDialog,
    TeamTransferDialog
  },
  props: {
    config: { type: Object, required: true },
    persons: { type: Array, required: true },
    team: { type: Object, required: true },
    estimate: { type: Number, required: false, default: null },
    estimateMinimum: { type: Number, required: false, default: 0 },
    error: { type: Boolean, default: false },
    showEstimationDialog: { type: Boolean, default: false },
    showTransferDialog: { type: Boolean, default: false },
    categories: { type: Object, required: false },
    playersException: {
      type: [Array, Boolean],
      default: false
    },
    transferError: {
      type: String,
      default: ''
    },
    isTransferring: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      confirmPopUpDialog: false,
      deleteId: null,
      showEstimation: false,
      inputEstimate: '',
      showEstimationError: false,
      personTransferId: null
    }
  },
  computed: {
    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  methods: {
    onDialogToggle (val) {
      this.$emit('toggle-estimation-dialog', val)
    },
    onTransferDialog (val) {
      this.$emit('toggle-transfer-dialog', val)
    },
    onOpenTransferDialog (val) {
      this.personTransferId = val
      this.$emit('toggle-transfer-dialog', true)
    },
    openProfile (id) {
      this.$router.push({ name: this.config.routes.view, params: { person_id: id } }).catch(() => {})
    },
    openDialog (id) {
      this.deleteId = id
      this.confirmPopUpDialog = true
    },
    deleteConfirm () {
      this.confirmPopUpDialog = false
      const team = this.team && this.team.team ? this.team.team : null
      if (!team || !team.id) return

      const id = this.deleteId
      this.$store.dispatch(this.config.routes.removeAction, {
        person_id: this.deleteId,
        team_id: team.id
      }).then(() => {
        this.$emit('remove', id)
      })
    },
    cancel () {
      this.confirmPopUpDialog = false
      this.deleteId = null
    },
    openEstimation () {
      if (this.estimate != null) {
        this.showEstimationError = true
      } else {
        this.showEstimationError = false
        this.$emit('toggle-estimation-dialog', true)
      }
    },
    onUpdateEstimate (newVal) {
      this.$emit('update', newVal)
    },
    onTransferConfirm (teamId) {
      this.$emit('transfer', this.personTransferId, teamId)
    },
    onErrorEstimate (error) {
      this.$emit('error', error)
    },
    errorKey () {
      const categoryName = this.team && this.team.team && this.team.team.category && this.team.team.category.name
      return this.config.estimate.errorKey(categoryName || '')
    }
  }
}
</script>

<style lang="scss" scoped>
#list {
  margin-top: 20px;
}
.estimation-search-row {
  margin-bottom: 12px;
}
</style>
